<template>
  <div class="c-record-kpi">
    <!-- filter -->
    <div class="c-filter">
      <div class="c-form">
        <ElForm label-width="80" inline class="elementui-common-form-styles" v-highlight>
          <ElFormItem label="月份">
            <ElDatePicker
              v-model="month"
              value-format="yyyy-MM"
              type="month"
              :options="datetimeOption"
              placeholder="不限"
              style="width: 180px"
              @change="setMonth"
            >
            </ElDatePicker>
          </ElFormItem>

          <ElFormItem class="bg-transparent" label-width="0">
            <ElButton type="primary" @click="addRecord(0)">新增方案</ElButton>
          </ElFormItem>
        </ElForm>
      </div>
    </div>
    <div class="c-table-list">
      <Viewport v-model="tableHeight" v-loading="loading">
        <design-kpi-table
          :height="tableHeight"
          :data="tableList"
          :columns="tableCol"
          @on-edit="addRecord"
          @on-del="delRecord"
          @on-refresh="getData"
        />

        <el-pagination
          :total="total"
          :current-page.sync="pageIndex"
          :page-size="pageSize"
          :page-sizes="[10, 20, 30, 40, 100]"
          layout="total, sizes, prev, pager, next, jumper"
          @current-change="changePageIndex"
          @size-change="changePageSize"
          class="c-table-page pager"
          background
        />
      </Viewport>
    </div>
    <!-- 弹出框 -->
    <set-design
      v-model="model"
      title="设计奖金方案"
      :datetime-option="datetimeOption"
      :loading="loading"
      :edit="edit"
      :info="info"
      @on-save="saveRecord"
    />
  </div>
</template>
<script>
import mixin from '../mixins/mixin'
import columns from '../data/design_kpi_column'
import { setLocal, getLocal } from '@/common/js/api'
import { isArray, isEmpty, formatDate } from '@/common/js/utils'
import { setDesignKpi, updateDesignKpi, delDesignKpi, getDesignKpiList } from '@/api/manage.model'
import DesignKpiTable from './components/design-kpi-table'
import SetDesign from './components/set-design'

export default {
  name: 'designKpi',
  mixins: [mixin],
  components: { DesignKpiTable, SetDesign },
  methods: {
    getData(filter) {
      const params = {
        page_id: this.pageIndex,
        page_size: this.pageSize,
        check_time: this.month
      }
      // 加载状态
      this.loading = true
      getDesignKpiList(params)
        .then((data) => {
          this.loading = false
          if (data) {
            const { list, page_info } = data
            if (isArray(list) && page_info) {
              const { total_number } = page_info
              this.total = total_number || 0
              this.tableList = list
            }
          }
        })
        .catch((err) => {
          this.$Message.error({
            duration: 5,
            content: err
          })
        })
    },
    addRecord(edit) {
      this.edit = !!edit
      if (this.edit) {
        const { checkTime, threshold, type } = edit
        this.info = { month: checkTime, threshold, type }
        this.model = true
      } else {
        this.info = { month: '', type: '', threshold: '', hash: Math.random() }
        this.model = true
      }
    },
    saveRecord(params) {
      const { month, threshold, type } = params
      const { err, msg } = this.vaild({ month, threshold, type })
      if (err) {
        this.$Message.error({
          duration: 5,
          content: msg
        })
        return
      }
      const param = { check_time: month && formatDate(new Date(month), 'yyyy-MM'), threshold, type }
      const fnCallback = (data) => {
        this.loading = false
        if (data) {
          if (!this.edit) {
            this.pageIndex = 1
            this.edit = false
          }
          this.model = false
          this.getData()
        }
      }
      this.loading = true
      // 修改/新增
      if (this.edit) updateDesignKpi(param).then(fnCallback)
      else setDesignKpi(param).then(fnCallback)
    },
    delRecord(row) {
      const { checkTime, type } = row
      delDesignKpi({ check_time: checkTime, type }).then((data) => {
        if (data) this.getData()
      })
    },
    vaild(params) {
      const keys = Object.keys(params)
      const value = { month: '月份', threshold: '奖金起算金额', type: '类型' }
      let err = false
      let msg = ''
      keys.some((ret) => {
        if (!isEmpty(params[ret])) {
          if (ret === 'threshold' && (params[ret] > 99999999 || params[ret] <= 0)) {
            msg = `${value[ret]}大于0，小于99999999.00，最多2位小数`
            err = true
            return false
          }
        } else {
          msg = `${value[ret]}不能为空`
          err = true
          return false
        }
      })
      return { err, msg }
    },
    setLocalPage(size) {
      setLocal('DESIGN_KPI_PAGESIZE', size)
    },
    setMonth(val) {
      this.getData()
    }
  },
  data() {
    return {
      tableHeight: 330,
      model: null,
      loading: null,
      info: {},
      edit: null,
      month: '', // 月份
      datetimeOption: {
        disabledDate(date) {
          return date && date.valueOf() < new Date('2019-01-01 00:00:00')
        }
      }
    }
  },
  created() {
    this.pageSize = parseInt(getLocal('DESIGN_KPI_PAGESIZE')) || 20
    this.tableCol = columns
    this.getData()
  }
}
</script>
<style lang="scss" scoped>
.c-table-page {
  padding: 5px 0;
  text-align: right;
}
</style>
